export default "__VITE_ASSET__95897975__"